export const searchData = [
  {
    id: 1,
    title: "HR Operations & Administration",
    route: "/service/hr-operations-&-administration",
    description:
      "HR Operations & Administration services in Kerala ensure smooth workflows, compliance, and employee satisfaction.",
    keywords: [
      "HR services",
      "HR consultancy",
      "HR management",
      "Payroll services",
      "Employee data management",
      "HR compliance",
      "HR administration",
      "Leave management",
      "HR operations",
      "Employee offboarding",
      "HR support",
      "Employee management",
      "Attendance management",
      "HR documentation",
      "HR reporting",
      "Staff administration",
      "Recruitment support",
      "HR process automation",
      "HR record keeping",
      "Employee travel management",
    ],
  },
  {
    id: 2,
    title: "HR Planning & Organization",
    route: "/service/hr-planning-&-organization",
    description:
      "Strengthen businesses with HR Planning & Organization services in Kerala for people, policies, and performance.",
    keywords: [
      "HR planning",
      "Workforce planning",
      "Organizational design",
      "Job role definition",
      "Competency mapping",
      "Succession planning",
      "HR policy development",
      "Process development",
      "Talent management",
      "HR strategy",
      "Manpower planning",
      "Workforce structuring",
      "Organizational restructuring",
      "Job description creation",
      "Leadership development",
      "HR framework",
      "Employee role mapping",
      "HR process optimization",
      "Talent alignment",
      "HR solutions",
    ],
  },
  {
    id: 3,
    title: "Learning & Development",
    route: "/service/learning-&-development",
    description:
      "Drive productivity and growth using Learning & Development services in Kerala for every business.",
    keywords: [
      "Learning and development",
      "Employee training",
      "Skill development",
      "Leadership training",
      "Management training",
      "Soft skills training",
      "Behavioral training",
      "Corporate training",
      "Continuous learning",
      "Employee development",
    ],
  },
  {
    id: 4,
    title: "Payroll & Compensation",
    route: "/service/payroll-&-compensation",
    description:
      "Simplify payroll, incentives, and settlements through Payroll & Compensation services in Kerala today.",
    keywords: [
      "Payroll services",
      "Payroll management",
      "Salary processing",
      "Compensation management",
      "Payroll outsourcing",
      "Employee payroll",
      "Tax compliance",
      "Statutory compliance",
      "Payroll solutions",
      "HR payroll services",
    ],
  },
  {
    id: 5,
    title: "Recruitment Assistance",
    route: "/service/recruitment-assistance",
    description:
      "Find skilled professionals easily with recruitment services in Kerala across industries and business sizes.",
    keywords: [
      "Recruitment services",
      "Staffing solutions",
      "Manpower services",
      "HR outsourcing",
      "Executive search",
      "Head hunting",
      "Bulk recruitment",
      "Campus hiring",
      "Workforce recruitment",
      "Talent acquisition",
    ],
  },
  {
    id: 6,
    title: "Quality Assurance & Compliance",
    route: "/service/quality-assurance-&-compliance",
    description:
      "Custom HR workshops, HRMS software implementation, engagement frameworks, and annual HR retainers",
    keywords: [
      "Talent acquisition",
      "Recruitment services",
      "Employee onboarding",
      "Strategic hiring",
      "Candidate assessment",
      "Employer branding",
      "Workforce recruitment",
      "Employee orientation",
      "Talent selection",
      "Onboarding solutions",
    ],
  },
  {
    id: 7,
    title: "Quality Assurance & Compliance",
    route: "/service/quality-assurance-&-compliance",
    description:
      "Custom HR workshops, HRMS software implementation, engagement frameworks, and annual HR retainers",
    keywords: [
      "Talent acquisition",
      "Recruitment services",
      "Employee onboarding",
      "Strategic hiring",
      "Candidate assessment",
      "Employer branding",
      "Workforce recruitment",
      "Employee orientation",
      "Talent selection",
      "Onboarding solutions",
    ],
  },
  {
    id: 8,
    title: "HR Policy & Procedure ",
    route: "/service/hr-policy-&-procedure",
    description:
      "HR policies set rules defining employer-employee roles, while procedures ensure proper implementation within organizations.",
    keywords: [
      "HR policies",
      "HR procedures",
      "Policy framework",
      "Code of conduct",
      "Leave policies",
      "Attendance policies",
      "Compensation framework",
      "Performance appraisal",
      "Employee welfare",
      "Workplace guidelines",
    ],
  },
  {
    id: 9,
    title: "Staff Appraisal System ",
    route: "/service/staff-appraisal-system",
    description:
      "Staff Appraisal System identifies employee strengths and weaknesses, aligns performance with business goals, and enhances growth.",
    keywords: [
      "Staff appraisal",
      "Performance appraisal",
      "Employee evaluation",
      "Appraisal system",
      "Talent assessment",
      "Performance management",
      "Employee development",
      "Skill assessment",
      "Goal setting",
      "Performance improvement",
    ],
  },
  {
    id: 10,
    title: "Training & Development ",
    route: "/service/traing-&-development",
    description:
      "Training & Development Services in Calicut, Kerala empower employees, enhance skills, and transform talent into organizational leaders.",
    keywords: [
      "Training services",
      "Employee development",
      "Skill enhancement",
      "Leadership training",
      "Career development",
      "Performance improvement",
      "Mentorship programs",
      "Talent development",
      "Organizational development",
      "Professional training",
    ],
  },
  {
    id: 11,
    title: "Customer Care Orientation ",
    route: "/service/customer-care-orientation",
    description:
      "Befirst HR Consulting provides customized customer care training, ensuring staff build strong relationships and retain every customer.",
    keywords: [
      "Customer care",
      "Customer service training",
      "Service excellence",
      "Customer interaction",
      "Complaint handling",
      "Emotional intelligence training",
      "Relationship building",
      "Feedback management",
      "Staff training",
      "Customer engagement",
    ],
  },
  {
    id: 101,
    title: "Why Choose a Leading HR Consultancy in Calicut, Kerala?",
    route: "/blogs/why-choose-a-leading-hr-consultancy-in-calicut-kerala",
    description:
      "Running a business in today’s competitive environment requires more than just good products and services. It demands.",
    keywords: [
      "HR consultancy in Calicut",
      "HR consultancy in Kerala",
      "Leading HR consultancy",
      "HR services in Kerala",
      "Payroll services in Kerala",
      "Payroll outsourcing Kerala",
      "Salary processing Kerala",
      "Recruitment outsourcing Kerala",
      "Hiring solutions Kerala",
      "Talent management Kerala",
      "Compliance management Kerala",
      "Labour law compliance Kerala",
      "Statutory compliance Kerala",
      "HR outsourcing in Kerala",
      "HR administration Kerala",
      "Employee engagement Kerala",
      "Performance management Kerala",
      "SME HR solutions Kerala",
      "Corporate HR services Kerala",
      "Befirst HR consultancy",
    ],
  },
  {
    id: 102,
    title: "Recruitment Outsourcing in Kerala: Why SMEs Should Consider It",
    route: "/blogs/recruitment-outsourcing-in-kerala",
    description:
      "Recruitment is often one of the most time-consuming and costly processes for businesses. For small and medium.",
    keywords: [
      "Recruitment outsourcing Kerala",
      "Recruitment services Kerala",
      "Staffing solutions Kerala",
      "HR consultancy Kerala",
      "SME recruitment Kerala",
      "Hiring solutions Kerala",
      "Recruitment agencies Kerala",
      "Recruitment process outsourcing Kerala",
      "Talent acquisition Kerala",
      "Employee onboarding Kerala",
      "Cost-effective hiring Kerala",
      "Compliance recruitment Kerala",
      "Recruitment for SMEs Kerala",
      "HR consulting Kerala",
      "Recruitment support Kerala",
      "Workforce recruitment Kerala",
      "Faster hiring Kerala",
      "Industry-specific recruitment Kerala",
      "Scalable recruitment Kerala",
      "Flexible hiring solutions Kerala",
    ],
  },
  {
    id: 103,
    title: "Top 10 Payroll Mistakes SMEs in Kerala Must Avoid",
    route: "/blogs/payroll-outsourcing-in-kerala",
    description:
      "Managing payroll is one of the most challenging aspects for small and medium enterprises (SMEs) in Kerala.",
    keywords: [
      "Payroll services Kerala",
      "Payroll outsourcing Kerala",
      "Salary processing Kerala",
      "Employee payroll Kerala",
      "Payroll management Kerala",
      "HR and payroll services Kerala",
      "Payroll compliance Kerala",
      "Kerala labour law compliance",
      "Tax deductions Kerala",
      "EPF and ESI Kerala",
      "Compensation management Kerala",
      "Payroll record-keeping Kerala",
      "Overtime payments Kerala",
      "Payroll software Kerala",
      "Final settlement Kerala",
      "Exit payroll process Kerala",
      "Payroll solutions Kerala",
      "Payroll errors Kerala",
      "Payroll support Kerala",
      "SME payroll services Kerala",
    ],
  },
  {
    id: 104,
    title: "The Complete Guide to HR Compliance in Kerala",
    route: "/blogs/the-complete-guide-to-hr-compliance-in-kerala",
    description:
      "Running a business in Kerala is not only about offering good products or services. It also means.",
    keywords: [
      "HR compliance Kerala",
      "HR compliance services Kerala",
      "Kerala labour law compliance",
      "Payroll compliance Kerala",
      "PF and ESI Kerala",
      "TDS filing Kerala",
      "Professional tax Kerala",
      "Compliance audit Kerala",
      "Employee documentation Kerala",
      "HR policies Kerala",
      "HR contracts Kerala",
      "Appointment letters Kerala",
      "Workplace compliance Kerala",
      "SME HR compliance Kerala",
      "HR statutory support Kerala",
      "HR compliance audits Kerala",
      "Labour law updates Kerala",
      "Employee benefits Kerala",
      "Minimum wages Kerala",
      "HR consultancy Kerala",
    ],
  },
  {
    id: 105,
    title: "How to Choose the Right HR Consultancy in Calicut",
    route: "/blogs/how-to-choose-the-right-hr-consultancy-in-calicut",
    description:
      "Finding and keeping the right talent is one of the biggest challenges for small and medium businesses in Kerala.",
    keywords: [
      "HR consultancy Calicut",
      "HR services Calicut",
      "Befirst HR Calicut",
      "HR consultancy Kerala",
      "HR solutions for SMEs Kerala",
      "Recruitment services Calicut",
      "Payroll management Calicut",
      "Employee training Calicut",
      "HR compliance Kerala",
      "Talent acquisition Calicut",
      "Employee engagement Calicut",
      "Performance management Calicut",
      "HR support for SMEs Kerala",
      "HR strategy Calicut",
      "Local HR consultancy Kerala",
      "SME HR services Calicut",
      "Human resource management Calicut",
      "HR outsourcing Kerala",
      "Customized HR solutions Calicut",
      "Trusted HR partner Kerala",
    ],
  },
];

// Function to search through the data
export const searchServices = (query) => {
  if (!query || query.trim() === "") {
    return [];
  }

  const searchTerm = query.toLowerCase().trim();

  return searchData.filter((service) => {
    // Search in title
    const titleMatch = service.title.toLowerCase().includes(searchTerm);

    // Search in description
    const descriptionMatch = service.description
      .toLowerCase()
      .includes(searchTerm);

    // Search in keywords
    const keywordMatch = service.keywords.some((keyword) =>
      keyword.toLowerCase().includes(searchTerm)
    );

    return titleMatch || descriptionMatch || keywordMatch;
  });
};

// Function to get search suggestions (limited results for dropdown)
export const getSearchSuggestions = (query, limit = 5) => {
  const results = searchServices(query);
  return results.slice(0, limit);
};
